window.global ||= window;

import * as Sentry from '@sentry/react';
import { initializeCurrentLocation } from '@takeshape/redux-little-router';
import { createRoot } from 'react-dom/client';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/400-italic.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/500-italic.css';
import '@fontsource/roboto/700.css';
import '@fontsource/roboto/700-italic.css';
import '@fontsource/roboto-mono/400.css';
import '@fontsource/roboto-mono/400-italic.css';
import '@fontsource/roboto-mono/700.css';
import '@fontsource/roboto-mono/700-italic.css';
import './common/utils/commons.css';
import './tailwind-daisyui.css';
import { getUser } from './auth/actions.js';
import { loadAuthState } from './auth/state.js';
import { sentryDSN } from './config.js';
import Root from './containers/root.js';
import { createReduxStore } from './store.js';

export type TakeShape = {
  playwright: boolean;
};

declare global {
  interface Window {
    takeshape: TakeShape;
  }
}

Sentry.init({
  dsn: sentryDSN,
  ignoreErrors: [
    // GraphiQL uncaught error on invalid enum in query variables
    /Value ".*" does not exist in ".*" enum./
  ]
});

const auth = loadAuthState();
// TODO correctly type
export const reduxStore = createReduxStore({ auth } as any);

// Refresh user permissions
if (auth.user) {
  reduxStore.dispatch(getUser.requested());
}

const initialLocation = reduxStore.getState().router;
if (initialLocation) {
  // TODO correctly type
  reduxStore.dispatch(initializeCurrentLocation(initialLocation as any));
}

const container = document.getElementById('app')!;
const root = createRoot(container);
root.render(<Root store={reduxStore} />);
